import React from "react";

export default function AviationBackground() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 pointer-events-none select-none z-0"
      style={{ background: "linear-gradient(180deg, #050810 0%, #0a0e1a 50%, #0d1630 100%)" }}
    >
      {/* Aviation grid */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,212,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,255,0.04) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />

      {/* Horizon glow */}
      <div
        className="absolute left-0 right-0"
        style={{
          top: "38%",
          height: "120px",
          background:
            "radial-gradient(ellipse 80% 60px at 50% 50%, rgba(0,212,255,0.07) 0%, transparent 100%)",
        }}
      />

      {/* Corner gradient accents */}
      <div
        className="absolute top-0 left-0"
        style={{
          width: "400px",
          height: "300px",
          background:
            "radial-gradient(ellipse at 0% 0%, rgba(30,58,138,0.25) 0%, transparent 70%)",
        }}
      />
      <div
        className="absolute bottom-0 right-0"
        style={{
          width: "500px",
          height: "400px",
          background:
            "radial-gradient(ellipse at 100% 100%, rgba(0,232,122,0.06) 0%, transparent 70%)",
        }}
      />

      {/* Stars / noise particles */}
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        {[
          [8, 12], [15, 28], [23, 7], [34, 42], [45, 18], [52, 35],
          [63, 9], [71, 56], [78, 22], [86, 38], [92, 14], [5, 68],
          [18, 74], [29, 82], [40, 64], [55, 78], [67, 88], [80, 72],
          [90, 82], [95, 55], [12, 90], [37, 95], [60, 92], [82, 96],
        ].map(([cx, cy], i) => (
          <circle
            key={i}
            cx={`${cx}%`}
            cy={`${cy}%`}
            r={i % 3 === 0 ? "1.2" : "0.7"}
            fill={`rgba(255,255,255,${i % 5 === 0 ? 0.18 : 0.1})`}
          />
        ))}
      </svg>

      {/* Runway perspective lines at bottom */}
      <svg
        className="absolute bottom-0 left-0 right-0"
        viewBox="0 0 100 30"
        preserveAspectRatio="none"
        height="180"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="rwGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="rgba(0,212,255,0.18)" />
            <stop offset="100%" stopColor="rgba(0,212,255,0)" />
          </linearGradient>
        </defs>
        <path d="M 50,0 L 10,30 L 90,30 Z" fill="url(#rwGrad)" />
        <line x1="50" y1="0" x2="10" y2="30" stroke="rgba(0,212,255,0.12)" strokeWidth="0.3" />
        <line x1="50" y1="0" x2="90" y2="30" stroke="rgba(0,212,255,0.12)" strokeWidth="0.3" />
        {[5, 10, 15, 20, 25].map((y) => (
          <line
            key={y}
            x1={50 - (y * 2)}
            y1={y}
            x2={50 + (y * 2)}
            y2={y}
            stroke="rgba(0,212,255,0.07)"
            strokeWidth="0.3"
          />
        ))}
      </svg>
    </div>
  );
}
